// import store from "@/state/store";
import Vue from 'vue'
import { getModuleAccess } from '@/helpers/helper.js'
import ToastPlugin from '@/plugins/toast';
Vue.use(ToastPlugin);



export default [
  {
    path: "/",
    alias: ["/dashboard"],
    name: "home",
    meta: {
      authRequired: true,
    }
  },
  {
    path: "/wallet",
    name: "wallet",
    redirect: '/wallet/topup',
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/wallet/main-view"),
    children: [
      {
        path: "topup",
        name: "wallet-topup",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/wallet/topup-view"),
      },
      {
        path: "logs",
        name: "wallet-logs",
        props: true,
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/wallet/logs-view"),
      },
      {
        path: "payment/:status/:module/:skuAmount/:methodId",
        name: "wallet-payment",
        props: true,
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/wallet/payment-view"),
      }
    ]
  },
  // {
  //   path: "/my-checkout",
  //   name: "my-checkout",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/dashboards/sales/index"),
  //   beforeEnter: async (to, from, next) => {
  //     await getModuleAccess("Find Space", "My Checkout").then((access) => {
  //       if(access.create || access.read || access.update || access.delete) {
  //         next()
  //       } else {
  //         Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
  //         next(from.path)
  //       }
  //     })
  //   }
  // },
  // {
  //   path: "/confirm-order",
  //   name: "confirm-order",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/checkout/index"),
  //   beforeEnter: async (to, from, next) => {
  //     await getModuleAccess("Find Space", "My Checkout").then((access) => {
  //       if(access.create || access.read || access.delete) {
  //         next()
  //       } else {
  //         Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
  //         next(from.path)
  //       }
  //     })
  //   }
  // },
  // {
  //   path: "/collateral-setup",
  //   name: "collateral-setup",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/checkout/collateral-setup"),
  //   beforeEnter: async (to, from, next) => {
  //     await getModuleAccess("Find Space", "My Checkout").then((access) => {
  //       if(access.create) {
  //         next()
  //       } else {
  //         Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
  //         next(from.path)
  //       }
  //     })
  //   }
  // },
  // {
  //   path: "/favorite",
  //   name: "favorite",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/dashboards/sales/index"),
  // },
  {
    path: "/my-space",
    name: "my-space",
    meta: {
      authRequired: true,
    },
    redirect: "/my-space/campaigns",
    component: () => import("../views/pages/my-space/index"),
    children: [
      {
        path: "campaigns",
        name: "campaigns",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/my-space/campaigns"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("Manage Space", "My Space").then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      },
      {
        path: "campaign-details/:id",
        name: "campaign-details",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/my-space/campaign-details"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("Manage Space", "My Space").then((access) => {
            if(access.read) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      },
      {
        path: "campaign-details/:id/collaterals",
        name: "campaign-collaterals",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/my-space/collateral-list"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("Manage Space", "My Space").then((access) => {
            if(access.read) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      },
      {
        path: "campaign-details/store/:id/:chid/:pid",
        name: "store-campaign-details",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/my-space/store-campaign-details"),
      },
    ]
  },
  {
    path: "/audit-space",
    name: "audit-space",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/audit-space/index"),
    beforeEnter: async (to, from, next) => {
      await getModuleAccess("Manage Space", "Audit Space").then((access) => {
        if(access.create || access.read || access.update || access.delete) {
          next()
        } else {
          Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
          next(from.path)
        }
      })
    }
  },
  {
    path: "/management",
    name: "management",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/user-management/index"),
    children: [
      {
        path: "users",
        name: "users",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/user-management/users/index"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("User Management", "Users").then((access) => {
            if(access.create || access.read || access.update || access.delete) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      },
      {
        path: "users/add",
        name: "add-user",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/user-management/users/manage-user"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("User Management", "Users").then((access) => {
            if(access.create) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      },
      {
        path: "users/edit/:id",
        name: "edit-user",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/user-management/users/manage-user"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("User Management", "Users").then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      },
      // {
      //   path: "roles",
      //   name: "roles",
      //   meta: {
      //     authRequired: true,
      //   },
      //   props: true,
      //   component: () => import("../views/pages/user-management/roles/index"),
      //   beforeEnter: async (to, from, next) => {
      //     await getModuleAccess("User Management", "Roles").then((access) => {
      //       if(access.create || access.read || access.update || access.delete) {
      //         next()
      //       } else {
      //         Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
      //         next(from.path)
      //       }
      //     })
      //   }
      // },
      {
        path: "roles/add",
        name: "add-role",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/user-management/roles/manage-role"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("User Management", "Roles").then((access) => {
            if(access.create) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      },
      {
        path: "roles/edit/:id",
        name: "edit-role",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/user-management/roles/manage-role"),
        beforeEnter: async (to, from, next) => {
          await getModuleAccess("User Management", "Roles").then((access) => {
            if(access.read || access.update) {
              next()
            } else {
              Vue.prototype.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
              next(from.path)
            }
          })
        }
      }
    ]
  },
  // {
  //   path: "/listings",
  //   name: "listings",
  //   meta: {
  //     authRequired: true,
  //   },
  //   component: () => import("../views/pages/listings/main-view")
  // },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      authRequired: false
    },
  },
  {
    path: "/register",
    name: "register",
    props: true,
    component: () => import("../views/pages/account/register"),
    meta: {
      authRequired: false
    },
  },
  {
    path: "/browse-space",
    name: "browse-space",
    component: () => import("../views/pages/listings/browse-space"),
    meta: {
      authRequired: false
    },
  },
  {
    path: "/browse-space/:id",
    name: "browse-space-details",
    component: () => import("../views/pages/listings/browse-space-details"),
    meta: {
      authRequired: true
    },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    props: true,
    component: () => import("../views/pages/account/forgot-password"),
    meta: {
      authRequired: false
    },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("../views/pages/account/reset-password"),
    meta: {
      authRequired: false
    },
  },
  {
		path: "/pages/profile",
		name: "profile",
		component: () => import("../views/pages/account/profile/index"),
		meta: {
			authRequired: true,
		},
	},
  {
		path: "/pages/profile/edit",
		name: "edit-profile",
		component: () => import("../views/pages/account/profile/user-edit-details"),
		meta: {
			authRequired: true,
		},
	},
  {
		path: "/pages/profile/edit/password",
		name: "edit-profile-password",
		component: () => import("../views/pages/account/profile/user-change-password"),
		meta: {
			authRequired: true,
		},
	},
  // {
  //   path: "/favorites",
  //   name: "browse-space-favorites",
  //   component: () => import("../views/pages/listings/favorites/index"),
  //   meta: {
  //     authRequired: true
  //   },
  // },
  {
    path: "/page-not-found",
    name: "error-404-basic",
    component: () => import("../views/pages/errors/404-basic"),
  },
  { 
    path: "*",
    name: "page-not-found",
    redirect: "/page-not-found"  
  }
];
